/**
 * Vendors
 */
import React, { Component, Suspense } from 'react';
import { Helmet } from 'react-helmet';
import { string, number, bool } from 'prop-types';
import { Router, Switch } from 'react-router-dom';
import { createBrowserHistory } from 'history';

/**
 * Components
 */
import { defaultLocale, defaultTheme } from '../config';
import Loader from '@components/Loader/Loader';
export const history = createBrowserHistory();
import PrivateRoute from './PrivateRoute';
import { getEffectiveTheme } from '../utils/themeStorage';
// import ManagerFooter from '../themes/4/components/ManagerFooter/ManagerFooter';

/**
 * Default exports
 */
import SideBar from '@components/SideBar/SideBar';
// import SecondaryHeader from '@themes/4/components/Header/SecondaryHeader';
import HomePage from '@pages/home/HomePage';
import DashboardPage from '@pages/dashboard/index';
import StatisticsPage from '@pages/statistics/StatisticsPage';

import OffersPage from '@pages/offers/OffersPage/OffersPage';
import OfferNewsPage from '@pages/offers/OfferNewsPage';
import OfferPromoPage from '@pages/offers/OfferPromoPage';
import SourcesPage from '@pages/sources/SourcesPage';
import CreateSourcePage from '@pages/sources/CreateSourcePage';
import FlowsPage from '@pages/flows/FlowsPage/FlowsPage';
import CreateFlowPage from '@pages/flows/CreateFlowPage/CreateFlowPage';
import FlowPage from '@pages/flows/FlowPage/FlowPage';
// import CreateStreamTDSPage from '@pages/streamsTDS/CreateStreamTDSPage';
import StreamTDSPage from '@pages/streamsTDS/StreamTDSPage';
// import CreateDomainPage from '@pages/domains/CreateDomainPage';
import DomainPage from '@pages/domains/DomainPage';
// import BonusesPage from '@pages/bonuses/BonusesPage/BonusesPage';
// import AgenciesReplenishmentPage from '@pages/bonuses/AgenciesReplenishmentPage';
import PostbackLogsPage from '@pages/postback/PostbackLogsPage';
import NewsPage from '@pages/news/NewsPage/NewsPage';
import SingleNewsPage from '@pages/news/SingleNewsPage';
import RedirectToNewApiRoute from '@pages/transferRequestByIP/RedirectToNewApiRoute';
// import ProfileAvatarPage from '../themes/4/pages/avatar/ProfileAvatar';
// import DocsPage from '../themes/4/pages/docs/DocsPage';
// import ProfileApiPage from '@themes/3/pages/api/ProfileApiPage';
import TicketsPage from '@pages/tickets/TicketsPage/TicketsPage';
import CreateTicketPage from '@pages/tickets/CreateTicketPage';
// import TicketPage from '@pages/tickets/TicketPage';
import FaqPage from '@pages/faq/FaqPage';
import MasterAccountPage from '@pages/masterAccount/MasterAccountPage';
import GeneralStatisticsPage from '@pages/masterAccount/GeneralStatisticsPage';
// import LogoutPage from '@pages/logout/LogoutPage';
import NotFoundPage from '@pages/errors/NotFoundPage';
import ProfileInfoPage from '@themes/4/pages/profile/ProfileInfoPage';
// import ContactsPage from '@themes/4/pages/contacts/ContactsPage';
// import TelegramPage from '@themes/4/pages/telegram/TelegramPage';
// import ThemesPopup from '@components/ThemesPopup/ThemesPopup';
import SecurityPageDefault from '@pages/security/SecurityPage/SecurityPage';
// import LiveChatContainer from '../components/LiveChat/LiveChatContainer';
// import MobileAppsPage from '../pages/mobileApps/MobileAppsPage'
// import MobileAppSettingsPage from '../pages/mobileApps/MobileAppSettingsPage'
// import CreateNewDeeplink from '../components/MobileApps/MobileAppTools/CreateNewDeeplink'
// import PresetModal from '../modals/PresetModal/PresetModal'
// import PresetModal from '../modals/PresetModal/PresetModal';
// import ThemesChangeScheduled from '../modals/ThemesChangeScheduledModal/ThemesChangeScheduledModal';
// import TikTokCabinetPage from '@pages/tiktok/TikTokCabinetPage';
// import CreateTikTokCabinetPage from '@pages/tiktok/CreateTikTokCabinetPage';
// import TikTokCabinetRUBPage from '@pages/tiktokRUB/TikTokCabinetRUBPage';
// import CreateTikTokCabinetRUBPage from '@pages/tiktokRUB/CreateTikTokCabinetRUBPage';

/**
 * Named exports
 */
import { ThemedContractsPage as ContractsPage } from '@pages/contracts';
import { ThemedProfilePage as ProfilePage } from '@pages/profile/';
// import { ThemedSocialsPage as SocialsPage } from '@pages/socials/';
import { ThemedPaymentDataPage as PaymentDataPage } from '@pages/payment/';
import { TransferRequestByIPPage } from '@pages/transferRequestByIP/';
// import { ThemedDomainsPage as DomainsPage } from '@pages/domains/';
import { ThemedGlobalPostbackPage as GlobalPostbackPage } from '@pages/postback/';
import OfferPage from '@pages/offers/OfferPage/OfferPage';
import { ThemedFinancesPage as FinancesPage } from '@pages/finances/';
import { ThemedNotificationsPage as NotificationsPage } from '@pages/notifications/';
// import { ThemedChangePasswordPage as ChangePasswordPage } from '@pages/password/';

/**
 * Redirects
 */
// import { renderRedirects } from './themesRedirects';
// import PromoPage from '../pages/promo/PromoPage';
import CustomToast from '../components/Toast/Toast';
import HeaderMobile from '../components/HeaderMobile/HeaderMobile';

/**
 * Router
 */
class AppRouter extends Component {
  static propTypes = {
    language: string.isRequired,
    theme: number.isRequired,
    logoutFetching: bool,
  };
  static defaultProps = {
    language: defaultLocale,
    theme: defaultTheme,
  };

  inProfile = () => {
    switch (history.location.pathname) {
      case '/profile/info':
      case '/profile/edit':
      case '/profile/password':
      // case '/profile/notifications':
      case '/profile/payment-data':
      case '/profile/avatar':
        return true;

      default:
        return false;
    }
  };

  render() {
    const { language, theme, logoutFetching, documents } = this.props;
    const effectiveTheme = getEffectiveTheme(theme);
    return (
      <Router history={history}>
        <div id="layout" className={`lang ${language}`}>
          <Suspense fallback={<Loader />}>
            <Helmet
              // htmlAttributes={{ lang: language, class: 'theme-4' }}
              htmlAttributes={{ lang: language, class: `theme-${effectiveTheme}` }}
            />

            {logoutFetching ? null : (
              <>
                <HeaderMobile />
                <SideBar />
              </>
            )}

            {/* {logoutFetching || theme !== 4 ? null : <SecondaryHeader history={history} />} */}
            <Switch>
              {/* специфичные редиректы для тем */}
              {/* {renderRedirects(theme)} */}

              <PrivateRoute path="/" component={HomePage} exact />
              <PrivateRoute path="/dashboard" component={DashboardPage} />
              <PrivateRoute path="/statistics" component={StatisticsPage} exact />
              {/* {theme === 4 && <PrivateRoute path="/contacts" component={ContactsPage} exact />} */}
              <PrivateRoute path="/offers" component={OffersPage} exact />
              <PrivateRoute path="/offers/:tab([a-zA-Z]+)" component={OffersPage} exact />
              <PrivateRoute path="/offers/:id([0-9]+)" component={OfferPage} exact />
              <PrivateRoute path="/offers/:id/news" component={OfferNewsPage} />
              <PrivateRoute path="/offers/:id/files" component={OfferPromoPage} />
              {/* <PrivateRoute path="/tools/sources" component={SourcesPage} exact />
              <PrivateRoute path="/tools/sources/create" component={CreateSourcePage} /> */}
              <PrivateRoute path="/tools/flows" component={FlowsPage} exact />
              <PrivateRoute path="/tools/flows/create" component={CreateFlowPage} exact />
              {/* <PrivateRoute path={theme === 3 ? `/flows/create` : `/tools/flows/create`} component={CreateFlowPage} exact /> */}
              <PrivateRoute path="/tools/flows/:id([0-9]+)" component={FlowPage} exact />
              {/* <PrivateRoute
                path="/tools/streams/tds/create"
                component={CreateStreamTDSPage}
                exact
              /> */}
              <PrivateRoute path="/tools/streams/tds/:id([0-9]+)" component={StreamTDSPage} exact />
              {/* <PrivateRoute path="/tools/domains" component={DomainsPage} exact /> */}
              {/* <PrivateRoute path="/tools/domains/add" component={CreateDomainPage} exact /> */}
              {/* {theme !== 4 && ( */}
              <PrivateRoute
                path="/tools/domains/:type(landing|prelander|tracking|tds|click)/:id([0-9]+)"
                component={DomainPage}
                exact
              />
              {/* )} */}
              {/* <PrivateRoute path="/tools/bonuses" component={BonusesPage} exact /> */}
              {/* <PrivateRoute path="/tools/tiktok/create" component={CreateTikTokCabinetPage} exact />
              <PrivateRoute path="/tools/tiktok" component={TikTokCabinetPage} exact />
              <PrivateRoute path="/tools/tiktokRUB/create" component={CreateTikTokCabinetRUBPage} exact />
              <PrivateRoute path="/tools/tiktokRUB" component={TikTokCabinetRUBPage} exact /> */}
              {/* {theme === 3 && (
                <PrivateRoute path="/tools/bonuses/services" component={BonusesPage} exact />
              )} */}
              {/* {theme === 3 && (
                <PrivateRoute path="/tools/bonuses/bonuses" component={BonusesPage} exact />
              )} */}
              {/* <PrivateRoute path="/tools/bonuses/pay" component={AgenciesReplenishmentPage} exact /> */}
              <PrivateRoute path="/tools/global-postback" component={GlobalPostbackPage} exact />
              {/* {theme === 3 && (
                <PrivateRoute
                  path="/tools/global-postback/:id(logs)"
                  component={GlobalPostbackPage}
                  exact
                />
              )} */}
              <PrivateRoute
                path="/tools/global-postback/:id(logs)"
                component={PostbackLogsPage}
                exact
              />
              {/* <PrivateRoute path="/tools/api" component={TransferRequestByIPPage} exact /> */}
              <PrivateRoute path="/tools/transfer-by-api" component={RedirectToNewApiRoute} exact />
              {/* <PrivateRoute path="/tools/referral" component={ReferralsPage} exact /> */}
              <PrivateRoute path="/news" component={NewsPage} exact />
              <PrivateRoute path="/news/:id([0-9]+)" component={SingleNewsPage} exact />
              <PrivateRoute path="/postback/:id([0-9]+)" component={PostbackLogsPage} exact />
              <PrivateRoute path="/profile/info" component={ProfileInfoPage} />
              <PrivateRoute path="/profile/edit" component={ProfilePage} />
              {/* <PrivateRoute path="/profile/socials" component={SocialsPage} /> */}
              {/* <PrivateRoute path="/profile/payment-data" component={PaymentDataPage} /> */}
              <PrivateRoute path="/profile/payment-data" component={ContractsPage} />
              <PrivateRoute path="/profile/payments" component={FinancesPage} />
              {/* <PrivateRoute path="/profile/notifications" component={NotificationsPage} /> */}
              {/* <PrivateRoute path="/profile/password" component={ChangePasswordPage} /> */}
              {/* <PrivateRoute path="/profile/telegram" component={TelegramPage} /> */}
              {/* {theme === 3 && <PrivateRoute path="/profile/api" component={ProfileApiPage} exact />} */}

              <PrivateRoute path="/profile/security" component={SecurityPageDefault} exact />
              {/* {theme === 4 && (
                <PrivateRoute path="/profile/avatar" component={ProfileAvatarPage} exact />
              )} */}
              {/* {theme === 4 && <PrivateRoute path="/docs" component={DocsPage} exact />} */}
              {/* {documents && (
                <PrivateRoute path="/profile/contracts" component={ContractsPage} exact />
              )} */}

              {/* <PrivateRoute path="/promo" component={PromoPage} exact /> */}

              <PrivateRoute path="/tickets" component={TicketsPage} exact />
              <PrivateRoute path="/tickets/create" component={CreateTicketPage} exact />
              {/* <PrivateRoute path="/tickets/:id([0-9]+)" component={TicketPage} exact /> */}
              <PrivateRoute path="/faq/:faqPath*" component={FaqPage} exact />
              <PrivateRoute path="/tools/master" component={MasterAccountPage} exact />
              <PrivateRoute
                path="/tools/master/:id([0-9]+)"
                component={GeneralStatisticsPage}
                exact
              />

              {/* <PrivateRoute path="/tools/mobile-app" component={MobileAppsPage} exact />
              <PrivateRoute path="/tools/mobile-app/:id" component={MobileAppSettingsPage} exact />
              <PrivateRoute path="/tools/mobile-app/:id/create-deeplink" component={CreateNewDeeplink} exact /> */}

              {/* <PrivateRoute path="/logout" component={LogoutPage} exact /> */}
              {/* <PrivateRoute path="/preview/:id([0-9]+)" component={PreviewPage} exact /> */}
              {/* <PrivateRoute path="/testErrorPage" component={TestPage} exact /> */}
              <PrivateRoute component={NotFoundPage} />
            </Switch>
          </Suspense>
          {/* <ThemesPopup theme={theme} /> */}
          {/* <LiveChatContainer /> */}
          <CustomToast />
        </div>
        {/* {theme === 4 && <ManagerFooter history={history} />} */}
      </Router>
    );
  }
}

export default AppRouter;
